/**
 * @desc 学生模块
 */
const studentList = (r) =>
  require.ensure(
    [],
    () => r(require('../views/student/StudentList.vue')),
    'studentList'
  )

//原始班级
const sourceClass = (r) =>
  require.ensure(
    [],
    () => r(require('../views/student/SourceClass.vue')),
    'sourceClass'
  )
//原始班级
const gradeClass = (r) =>
  require.ensure(
    [],
    () => r(require('../views/student/gradeClass.vue')),
    'gradeClass'
  )

export default [
  //学生列表
  {
    name: 'studentList',
    path: '/studentList',
    component: studentList,
    meta: { title: '学生列表' },
  },
  //原始班级
  {
    name: 'sourceClass',
    path: '/sourceClass',
    component: sourceClass,
    meta: { title: '原始班级' },
  },
  //原始班级
  {
    name: 'gradeClass',
    path: '/gradeClass',
    component: gradeClass,
    meta: { title: '原始班级' },
  },
]
